export const CHANGE_CURRENT_STEP = 'CHANGE_CURRENT_STEP'
export const typeBooking = { single: 'SINGLE', multiple: 'MULTIPLE', ezSheet: 'EZ_SHEET', smartLoad: 'SMART_LOAD' }
